import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/base/PageSEO';
import HeroSection from './components/HeroSection';
import HotHeadlines from './components/HotHeadlines';
import LatestArticles from './components/LatestArticles';
import ReviewsSection from './components/ReviewsSection';
import BrandSection from './components/BrandSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '51黑料网',
      url: 'http://3kyzh.com/',
      description: '全网热门黑料爆料与吃瓜事件汇总平台，每日实时更新各类吃瓜黑料信息',
      sameAs: [
        'https://weibo.com/51heiliao',
        'https://weixin.qq.com/51heiliao',
      ],
    },
    {
      '@type': 'WebPage',
      name: '51黑料网 - 全网热门黑料爆料与吃瓜事件汇总平台',
      description: '51黑料网为您提供全网最新热门黑料爆料、明星吃瓜事件、网红八卦资讯等内容汇总',
      url: 'http://3kyzh.com/',
      isPartOf: {
        '@type': 'WebSite',
        name: '51黑料网',
        url: 'http://3kyzh.com/',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <PageSEO
        title="51黑料网 - 全网热门黑料爆料与吃瓜事件汇总平台"
        description="51黑料网为您提供全网最新热门黑料爆料、明星吃瓜事件、网红八卦资讯等内容汇总，每日实时更新各类吃瓜黑料信息，带您第一时间了解全网热点事件真相与最新动态。"
        keywords="51黑料网,黑料爆料,吃瓜事件,网红黑料,热门黑料汇总"
        canonical="http://3kyzh.com/"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotHeadlines />
        <LatestArticles />
        <ReviewsSection />
        <BrandSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
